import React from "react";

function Card({ children, className = "" }) {
  return (
    <div className={`bg-white shadow rounded-lg p-6 ${className}`}>
      {children}
    </div>
  );
}

function CardHeader({ children, className = "" }) {
  return <div className={`mb-4 ${className}`}>{children}</div>;
}

function CardTitle({ children, className = "" }) {
  return <h3 className={`text-lg font-semibold ${className}`}>{children}</h3>;
}

function CardContent({ children, className = "" }) {
  return <div className={`${className}`}>{children}</div>;
}

export { Card, CardHeader, CardTitle, CardContent };
export default Card;
